import { render } from "./vcoursewareclassify.vue?vue&type=template&id=a5cbda56&scoped=true"
import script from "./vcoursewareclassify.vue?vue&type=script&lang=js"
export * from "./vcoursewareclassify.vue?vue&type=script&lang=js"

import "./vcoursewareclassify.vue?vue&type=style&index=0&id=a5cbda56&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cbda56"]])

export default __exports__